export default "/images/framework/PinkBg.7ce4360e.svg?7ce4360e";